var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaywallBenefitMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2129 11.376C8.60449 11.376 5.72559 8.56152 5.72559 3.95312C5.72559 3.08301 5.97266 1.63281 6.2627 0.956055C6.34863 0.741211 6.35938 0.601562 6.35938 0.515625C6.35938 0.290039 6.1875 0.0107422 5.83301 0.0107422C5.73633 0.0107422 5.51074 0.0322266 5.28516 0.118164C2.11621 1.36426 0 4.75879 0 8.34668C0 13.3955 3.82422 16.9404 8.8623 16.9404C12.5576 16.9404 15.6836 14.7061 16.7363 11.9453C16.8115 11.7197 16.833 11.4941 16.833 11.4082C16.833 11.0752 16.5537 10.8604 16.3066 10.8604C16.1885 10.8604 16.0811 10.8818 15.8984 10.9355C15.2432 11.1504 14.2227 11.376 13.2129 11.376Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaywallBenefitMoonIcon);
export default __webpack_public_path__ + "static/media/paywall_benefit_moon_icon.6991a393cd22c0c69d9c1777798203f8.svg";
export { ForwardRef as ReactComponent };